import { reportDefaultNodeJsMetrics } from '@spotify-internal/semantic-metrics';
import { sendMetric } from '../../features/src/metrics';

if (!process.browser) {
  reportDefaultNodeJsMetrics(undefined, sendMetric);
}
